module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "main-wrapper",
    attrs: {
      "id": "app"
    }
  }, [_h('sidenav'), " ", _h('main', [_vm._m(0), " ", _h('section', {
    staticClass: "md-pages"
  }, [_h('router-view')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('header', [_h('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "ontouchend": "docs.toggleNavbar()",
      "id": "navbar-toggle"
    }
  }, [_h('span'), " ", _h('span'), " ", _h('span')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26288743!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/src/App.vue
// module id = 20
// module chunks = 1